import ConfirmModal from 'components/ConfirmModal';
import React from 'react';
import { useSelector } from 'react-redux';
import { getMaxLengthTranslation, getTranslationEmptyOrNullKey } from 'utils/getTranslation';
import style from './ConfirmDeleteSuscriptionsModal.module.scss';

const ConfirmDeleteSuscriptionsModal = ({
  show,
  handleConfirm,
  setShow,
  customTitle,
  customDescription,
  customConfirmText,
  customCancelText,
}) => {
  const translations = useSelector(state => state.translations);

  const confirmTitle =
    customTitle ??
    getMaxLengthTranslation(
      'MDP_AlertaEliminarTarjeta_Texto_Titulo',
      translations,
      72,
    );

  const descriptionTitle =
    customDescription ??
    getMaxLengthTranslation(
      'MDP_AlertaEliminarTarjeta_Texto_Parrafo',
      translations,
      82,
    );

  const confirmBtn =
    customConfirmText ??
    getTranslationEmptyOrNullKey(
      'MDP_AlertaEliminarTarjeta_Boton1_Texto',
      translations,
    );

  const closeBtn =
    customCancelText ??
    getTranslationEmptyOrNullKey(
      'MDP_AlertaEliminarTarjeta_Boton2_Texto',
      translations,
    );

  return (
    <ConfirmModal
      open={show}
      title={confirmTitle}
      description={descriptionTitle}
      confirmText={confirmBtn}
      cancelText={closeBtn}
      onConfirm={() => {
        handleConfirm();
      }}
      onCancel={() => setShow(false)}
      cssStyle={style}
      maxCharsPerLine={40}
    />
  );
};

export default ConfirmDeleteSuscriptionsModal;
